enum tipoBalanco {
        Anual,
        Semestral,
        Trimestral,
        Mensal
}

export default tipoBalanco;